import { createSelector } from 'reselect'
import { getPageData } from 'selectors/page'
export const getNewThisWeekAlgoliaResults = createSelector(
  getPageData,
  (pageData): Record<string, any> => pageData.newThisWeek || {}
)
export const getFeaturedSectionData = createSelector(
  getPageData,
  (pageData): Record<string, any> => pageData.featuredSectionData || {}
)
export const getCollectionTypes = createSelector(
  getPageData,
  (pageData): Record<string, any> => Object.keys(pageData.pageSlugifyDictionary) || {}
)
export const getPageSlugifyDictionary = createSelector(
  getPageData,
  (pageData): Record<string, any> => pageData.pageSlugifyDictionary || {}
)
export const getDefaultCollectionType = createSelector(
  getPageData,
  (pageData): Record<string, any> =>
    pageData.pageSlugifyDictionary[Object.keys(pageData.pageSlugifyDictionary)[0]] || ''
)
export const getAlgolia = (state: Record<string, any>): Record<string, any> => state.algolia || {}
export const getAlgoliaSlugifyDictionary = createSelector(
  [getAlgolia],
  (algolia): Record<string, any> => algolia.algoliaSlugifyDictionary || {}
)
export const getSelectedFacet = createSelector(
  [getAlgolia],
  (algolia): Record<string, any> => algolia.selectedFacets || {}
)
export const getSelectedCollectionTypeID = createSelector(
  [getSelectedFacet],
  (selectedFacets): number => selectedFacets.collection_types_ids || 0
)
export const getCollectionTitle = createSelector(
  [getSelectedCollectionTypeID, getAlgoliaSlugifyDictionary, getPageSlugifyDictionary],
  (collectionTypeID, algoliaSlugifyDictionary, pageSlugifyDictionary): string => {
    const algoliaCollectionType =
      Object.keys(algoliaSlugifyDictionary).find(
        (key) => algoliaSlugifyDictionary[key] === collectionTypeID
      ) || ''
    const collectionType =
      Object.keys(pageSlugifyDictionary).find(
        (key) => pageSlugifyDictionary[key] === algoliaCollectionType
      ) || ''
    return collectionType
  }
)
export const getCollectionTitleURL = createSelector(
  [getSelectedCollectionTypeID, getAlgoliaSlugifyDictionary],
  (collectionTypeID, algoliaSlugifyDictionary): string => {
    const algoliaCollectionType =
      Object.keys(algoliaSlugifyDictionary).find(
        (key) => algoliaSlugifyDictionary[key] === collectionTypeID
      ) || ''
    return algoliaCollectionType
  }
)